export interface FaqItem {
  q: string
  a: string
}

export const faqsSr: FaqItem[] = [
  {
    q: 'Garancija?',
    a: '12 meseci fabrička garancija za sva pravna lica, u skladu sa fabričkim standardima.',
  },
  {
    q: 'Servis?',
    a: 'Trenutno imamo serviserske partnere u Pančevu (Južnobanatski okrug) i u Beogradu — Surčin i Leštane. U toku su pregovori za dodatne regione.',
  },
  {
    q: 'Rok isporuke?',
    a: 'Zavisi od dostupnosti: modeli koji su na lageru isporučuju se istog dana, a modeli po narudžbini u roku od 4–6 nedelja iz proizvodnje. Za trenutno stanje lagera kontaktirajte nas.',
  },
  {
    q: 'Plaćanje?',
    a: 'Plaćanje po profakturi za pravna lica. Cene su u EUR bez PDV-a; obračun se vrši u dinarima po srednjem kursu NBS na dan plaćanja.',
  },
  {
    q: 'Da li mogu da vidim mašinu pre kupovine?',
    a: 'Kontaktirajte nas preko kontakt forme ili telefonom za više informacija o mašinama i mogućnostima razgledanja.',
  },
  {
    q: 'Da li isporučujete van Srbije?',
    a: 'Trenutno isporučujemo na teritoriji Srbije. Za regionalne porudžbine kontaktirajte nas direktno.',
  },
  {
    q: 'Da li se ljudi mogu prevoziti D-TECH mašinom?',
    a: 'Ne. D-TECH mašine su namenjene isključivo transportu tereta i nije dozvoljeno prevoziti ljude. Oprema nije projektovana, testirana ni sertifikovana za prevoz osoba, pa je svaka takva upotreba nebezbedna, u suprotnosti sa uputstvom za rukovanje i dovodi do gubitka garancije. Za prevoz ljudi koriste se isključivo uređaji sertifikovani za tu namenu.',
  },
  {
    q: 'Da li je D-TECH pogodan za osobe sa invaliditetom ili prevoz invalidskih kolica sa korisnikom?',
    a: 'Ne. Mašina nije rešenje za pristupačnost i ne sme se koristiti za prevoz osoba, uključujući osobe u invalidskim kolicima. Za tu namenu postoje posebno sertifikovani uređaji (stepenišne platforme, penjači za invalidska kolica i liftovi) koji podležu drugačijim bezbednosnim standardima. D-TECH oprema ostaje namenjena bezbednom transportu tereta.',
  },
]

export const faqsEn: FaqItem[] = [
  {
    q: 'Warranty?',
    a: '12 months factory warranty for all legal entities, in accordance with factory standards.',
  },
  {
    q: 'Service?',
    a: 'We currently have service partners in Pančevo (South Banat District) and in Belgrade — Surčin and Leštane. Negotiations for additional regions are ongoing.',
  },
  {
    q: 'Delivery time?',
    a: 'It depends on availability: models in stock can be delivered the same day, while models made to order arrive within 4–6 weeks from production. Contact us for current stock availability.',
  },
  {
    q: 'Payment?',
    a: 'Payment via proforma invoice for legal entities. Prices are in EUR without VAT; calculation is done in RSD at the NBS middle exchange rate on the day of payment.',
  },
  {
    q: 'Can I see the machine before buying?',
    a: 'Contact us via the contact form or phone for more details about the machines and viewing options.',
  },
  {
    q: 'Do you deliver outside Serbia?',
    a: 'We currently deliver within the territory of Serbia. For regional orders, contact us directly.',
  },
  {
    q: 'Can people be transported on a D-TECH machine?',
    a: 'No. D-TECH machines are intended exclusively for cargo transport and must never be used to carry people. The equipment is not designed, tested or certified for transporting persons, so any such use is unsafe, contrary to the operating instructions and voids the warranty. Only devices certified for passenger use may be used to transport people.',
  },
  {
    q: 'Is D-TECH suitable for people with disabilities or for moving an occupied wheelchair?',
    a: 'No. The machine is not an accessibility solution and must not be used to transport persons, including wheelchair users. Purpose-certified devices exist for that need (stair platforms, wheelchair stair climbers and lifts) and are subject to different safety standards. D-TECH equipment remains dedicated to the safe transport of cargo.',
  },
]

export const faqsRu: FaqItem[] = [
  {
    q: 'Гарантия?',
    a: 'Заводская гарантия 12 месяцев для всех юридических лиц в соответствии с заводскими стандартами.',
  },
  {
    q: 'Сервис?',
    a: 'В настоящее время у нас есть сервисные партнеры в Панчево (Южно-Банатский округ) и в Белграде — Сурчин и Лештане. Ведутся переговоры по дополнительным регионам.',
  },
  {
    q: 'Срок поставки?',
    a: 'Зависит от наличия: модели со склада отправляются в тот же день, а модели под заказ поставляются в течение 4–6 недель с производства. Свяжитесь с нами для уточнения наличия на складе.',
  },
  {
    q: 'Оплата?',
    a: 'Оплата по счету-проформе для юридических лиц. Цены указаны в евро без НДС; расчет производится в динарах по среднему курсу НБС на день оплаты.',
  },
  {
    q: 'Могу ли я увидеть машину перед покупкой?',
    a: 'Свяжитесь с нами через контактную форму или по телефону для получения дополнительной информации о машинах и возможностях осмотра.',
  },
  {
    q: 'Доставляете ли вы за пределы Сербии?',
    a: 'В настоящее время мы доставляем по территории Сербии. Для региональных заказов свяжитесь с нами напрямую.',
  },
  {
    q: 'Можно ли перевозить людей на машине D-TECH?',
    a: 'Нет. Машины D-TECH предназначены исключительно для транспортировки грузов, перевозка людей запрещена. Оборудование не спроектировано, не испытано и не сертифицировано для перевозки людей, поэтому такое использование небезопасно, противоречит инструкции по эксплуатации и приводит к потере гарантии. Для перевозки людей применяются только устройства, сертифицированные для этой цели.',
  },
  {
    q: 'Подходит ли D-TECH для людей с инвалидностью или для перемещения инвалидной коляски с пользователем?',
    a: 'Нет. Машина не является решением для обеспечения доступности и не должна использоваться для перевозки людей, включая пользователей инвалидных колясок. Для этих задач существуют специально сертифицированные устройства (лестничные платформы, подъёмники для инвалидных колясок и лифты), которые подчиняются другим стандартам безопасности. Оборудование D-TECH предназначено для безопасной транспортировки грузов.',
  },
]

export function getFaqs(lang: 'sr' | 'en' | 'ru'): FaqItem[] {
  if (lang === 'en') return faqsEn
  if (lang === 'ru') return faqsRu
  return faqsSr
}
